import React from 'react';

const DataDeletion = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto text-left">
      <h1 className="text-3xl font-bold mb-4">User Data Deletion Request</h1>
      <p className="mb-4">
        At <strong>Home Lead IQ</strong>, we take your privacy seriously. In compliance with Facebook’s platform policies and data regulations, we allow users to request the deletion of their data collected through our application.
      </p>
      <h2 className="text-xl font-semibold mb-2">How to Request Deletion</h2>
      <p className="mb-4">
        If you would like to request the deletion of your personal data collected through our Facebook integration, please send an email to <a href="mailto:privacy@homeleadiq.com" className="text-blue-500 underline">privacy@homeleadiq.com</a> with your Facebook User ID and a brief note requesting data removal.
      </p>
      <p className="mb-4">
        Alternatively, if you interacted with our Messenger bot, you may send the word <strong>"delete"</strong> and your request will be processed automatically.
      </p>
      <p className="text-sm text-gray-500">All deletion requests will be processed within 7 business days.</p>
    </div>
  );
};

export default DataDeletion;